import React, { useState } from 'react';
import { IoClose } from 'react-icons/io5';

import * as S from './styles';
import { LogoProps } from 'types/LogoProps';
import ConfirmScreen from 'components/ConfirmScreen';

interface ListLogosProps {
	list: LogoProps[];
	getLogoToEdit: any;
	deleteLogo: any;
}

export default function ListLogos({
	list,
	getLogoToEdit,
	deleteLogo
}: ListLogosProps) {
	const [isOpenBoxToDelete, setIsOpenToDelete] = useState(false);
	const [logoToDelete, setLogoToDelete] = useState<null | LogoProps>(null);

	return (
		<S.container>
			{list.length === 0 ? (
				<S.emptyList>
					<p>Não há logos cadastradas</p>
				</S.emptyList>
			) : (
				<S.list>
					{list.map((item) => (
						<S.item key={item.id}>
							<IoClose
								onClick={() => {
									setLogoToDelete(item);
									setIsOpenToDelete(true);
								}}
							/>
							<S.content
								onClick={() => {
									getLogoToEdit(item);
								}}
							>
								<img src={item.urlLogo} alt={item.name} />
								<p>{item.name}</p>
							</S.content>
						</S.item>
					))}
				</S.list>
			)}

			<ConfirmScreen
				title="Tela de confirmação"
				isOpen={isOpenBoxToDelete}
				setIsOpen={setIsOpenToDelete}
				buttonClose={false}
				functioToExecOnClose={() => {}}
				functionToExecOnConfirm={async () => {
					const isSuccess = await deleteLogo(logoToDelete);

					if (isSuccess) {
						setLogoToDelete(null);
						setIsOpenToDelete(false);
					}
				}}
				message={
					<p>
						Tem certeza que deseja deletar a logo
						<b> {` "${logoToDelete?.name || 'Sem nome'}"`}</b>.
					</p>
				}
			/>
		</S.container>
	);
}
